
import { testimonialsDataNew } from '../../data/Data';
import { FaStar } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
const TestimonialsNew = () => {
    return (
        <div className="font-basefont mt-10">
            <Helmet>
                <title>Client Testimonials | Global Business Feedback | PG Overseas Services</title>
                <meta
                    name="description"
                    content="See what our global clients say about PG Overseas Services. Discover real testimonials from professionals and companies we've helped with migration, investment, and international business services."
                />
                <meta
                    name="keywords"
                    content="PG Overseas Services reviews, client testimonials, customer feedback, international business success stories, global client satisfaction, relocation reviews, migration service reviews"
                />
            </Helmet>
            <section className="py-16 bg-white px-4">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-20"
                >
                    <h2 className="text-4xl font-bold text-basecolor mb-4">
                        Trusted Client Testimonials from Global Partners
                    </h2>
                    {/* <p className="text-gray-600 max-w-2xl mx-auto">
                        Comprehensive solutions to help you navigate the complexities of global business and migration.
                    </p> */}
                </motion.div>
                <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8">
                    {testimonialsDataNew?.slice(0, 4).map((item, i) => (
                        <div key={i} className="bg-white p-6 rounded-xl shadow-md border border-gray-200">
                            <p className="text-3xl text-orange-400 mb-4">❝</p>
                            <p className="text-gray-700 mb-6">{item.quote}</p>

                            <div className="flex items-center mt-4">
                                <div className="w-12 h-12 rounded-full overflow-hidden mr-4">
                                    <img
                                        src={item.image} alt={item.company}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div>
                                    <h4 className="font-semibold text-basecolor">{item.name}</h4>
                                    <p className="text-gray-600 text-sm">{item.title}</p>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            </section>

            {/* <section className="py-16 bg-white px-4">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl font-bold text-basecolor mb-4">Video Testimonials</h2>

                </motion.div>
                <div className="flex justify-center flex-wrap gap-8">
                    {testimonialsDataNew?.slice(0, 3).map((item, i) => (
                        <div key={i} className="relative w-64 h-72 rounded-xl overflow-hidden shadow-lg">
                            <img
                                src={item.image}
                                alt={item.name}
                                className="w-full h-full object-cover"
                            />
                            <button className="absolute inset-0 flex items-center justify-center bg-black/30 text-white text-4xl">
                                ▶
                            </button>
                            <div className="absolute bottom-2 left-2 text-white text-sm bg-black/60 px-2 py-1 rounded">
                                {item.name}
                            </div>
                        </div>
                    ))}
                </div>
            </section> */}

            {/* <section className="bg-bgpalecolor py-20 px-4 text-center">
                <div className="max-w-3xl mx-auto">
                    <p className="text-4xl text-orange-400 mb-4">❝</p>
                    <p className="text-lg text-gray-700 mb-6">{testimonialsDataNew[0].quote}</p>
                    <div className="flex items-center justify-center gap-4">
                        <img
                            src={testimonialsDataNew[0].image}
                            alt={testimonialsDataNew[0].name}
                            className="w-20 h-20 rounded-full object-cover"
                        />
                        <div className="text-left">
                            <p className="font-bold text-gray-800">{testimonialsDataNew[0].name}</p>
                            <p className="text-sm text-gray-500">{testimonialsDataNew[0].title}</p>
                            <div className="flex text-yellow-400 mt-1">
                                {[...Array(5)].map((_, i) => <FaStar key={i} />)}
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
        </div>
    );
};

export default TestimonialsNew;
